import { LOGISTICS_PERMISSIONS } from 'modules/inventory/provider/logistics/constants/logistics.permissions';
import { SUPPLIER_PERMISSIONS } from 'modules/inventory/provider/supplier/constants/supplier.permissions';
import { WAREHOUSE_PERMISSIONS } from 'modules/inventory/warehouse/constants/warehouse.permissions';
import { DISTRIBUTION_CENTER_PERMISSIONS } from 'modules/inventory/distribution-centers/constants/distribution-centers.permissions';

export const LogisticProvider = 'LOGISTIC';
export const SupplierProvider = 'SUPPLIER';

export enum PROVIDER_TYPE_ENUM {
  SUPPLIER = 'SUPPLIER',
  LOGISTIC = 'LOGISTIC',
  DISTRIBUTION_CENTER = 'DISTRIBUTION_CENTER',
  WAREHOUSE = 'WAREHOUSE',
  CARRIER = 'CARRIER',
  DRIVER = 'DRIVER',
  INTERNAL = 'INTERNAL',
}

export const PROVIDER_TYPE_MAP: any = {
  [PROVIDER_TYPE_ENUM.LOGISTIC]: 'logistics',
  [PROVIDER_TYPE_ENUM.SUPPLIER]: 'suppliers',
  [PROVIDER_TYPE_ENUM.WAREHOUSE]: 'warehouse',
  [PROVIDER_TYPE_ENUM.DISTRIBUTION_CENTER]: 'distribution-center',
  [PROVIDER_TYPE_ENUM.CARRIER]: 'carrier',
  [PROVIDER_TYPE_ENUM.DRIVER]: 'drivers',
};

export const PROVIDER_TYPE_PERMISSIONS: Record<any, string | undefined> = {
  [PROVIDER_TYPE_ENUM.LOGISTIC]: LOGISTICS_PERMISSIONS.LOGISTICS_VIEW,
  [PROVIDER_TYPE_ENUM.SUPPLIER]: SUPPLIER_PERMISSIONS.SUPPLIER_VIEW,
  [PROVIDER_TYPE_ENUM.WAREHOUSE]: WAREHOUSE_PERMISSIONS.WAREHOUSE_VIEW,
  [PROVIDER_TYPE_ENUM.DISTRIBUTION_CENTER]: DISTRIBUTION_CENTER_PERMISSIONS.DISTRIBUTION_CENTER_VIEW,
};

export const PROVIDER_TYPE_ROUTES: any = {
  [PROVIDER_TYPE_ENUM.LOGISTIC]: 'provider/logistics',
  [PROVIDER_TYPE_ENUM.SUPPLIER]: 'provider/suppliers',
  [PROVIDER_TYPE_ENUM.WAREHOUSE]: 'warehouses',
  [PROVIDER_TYPE_ENUM.DISTRIBUTION_CENTER]: 'distribution-centers',
  [PROVIDER_TYPE_ENUM.CARRIER]: 'provider/carriers',
};

export enum RESPONSIBLE_TYPE_ENUM {
  SUPPLIER = 'SUPPLIER',
  DISTRIBUTION_CENTER = 'DISTRIBUTION_CENTER',
  WAREHOUSE = 'WAREHOUSE',
  CARRIER = 'CARRIER',
  INTERNAL = 'INTERNAL',
}

export enum USERS_TYPE_ENUM {
  INTERNAL = 'INTERNAL',
  DRIVER = 'DRIVER',
  SUPPLIER = 'SUPPLIER',
  DISTRIBUTION_CENTER = 'DISTRIBUTION_CENTER',
  WAREHOUSE = 'WAREHOUSE',
  CARRIER = 'CARRIER',
}
